import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getIndexFromMultipleArray' })
export class GetIndexFromMultipleArrayPipe implements PipeTransform {

  /* transform(): Pipe que devuelve las propiedades requeridas de un array multidimensional
    array: Array multidimensional base
    index: propiedades requeridas
  */
  transform(array: any[], index: string | string[]): any[] {
    // Verifica si se solicita más de 1 propiedad
    if (typeof index === "object") {
      // ↓ Devuelve el array con las popiedades requeridas
      return array.map((elm: any[]) => {
        // arrayToReturn: Array que guadará el valor de cada propiedad solicitada por posición del array
        const arrayToReturn = [];
        // ↓ se iteran las propiedades solicitadas y se agregan al array creado ↑
        index.forEach((el: string) => arrayToReturn.push(elm[el]));
        // ↓ Devuelve el array de las propiedades del índice actual
        return arrayToReturn;
      });
    } else { return array.map((elm: any[] | {}) => elm[index as string]); }
    // ↑ Si sólo se solicita 1 propiedad se realiza un mapeo simple del array y se retorna el resultado
  }

}
